import React from 'react';

import { Loader } from './Loader';

export const FieldLoader = (props) => (
	<Loader sx={{ border: '1px solid', height: '40px', borderColor: 'gray.300', borderRadius: '3px' }} {...props} />
);
